import React, { useState } from 'react';
import '../../scss/components/Form.scss';
import '../../scss/components/LoginForm.scss';
import Card from '../Structure/Card.tsx';
import Button from '../Form/Button.tsx';
import TextInput from '../Form/TextInput.tsx';
import PasswordInput from '../Form/PasswordInput.tsx';
import SingleCheckbox from '../Form/SingleCheckbox.tsx';

import { useAuthContext } from '../../features/auth/hooks/use-auth-context.ts';
import { ApiResponseType } from '../../features/api/types.ts';
import { Link } from 'react-router-dom';

const LoginForm = () => {

    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [totpCode, setTotpCode] = useState('');
    const [stayLoggedIn, setStayLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [nameValid, setNameValid] = useState(true);
    const [passwordValid, setPasswordValid] = useState(true);
    const [totpRequired, setTotpRequired] = useState(false);
    
    const [responseMessage, setResponseMessage] = useState<String|Array<String>>('');
    const [responseMessageClass, setResponseMessageClass] = useState('');

    const { login } = useAuthContext();

    const captureLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        let errors = 0;
        if (name.length > 0) { setNameValid(true); } else { setNameValid(false); errors++; }
        if (password.length > 0) { setPasswordValid(true); } else { setPasswordValid(false); errors++; }

        if (errors > 0) {
            setIsLoading(false);
            return;
        }

        const loginPromise = login(name, password, totpRequired ? totpCode : null);
        loginPromise.then(res => {

            if (res.type === ApiResponseType.CLIENT_ERROR || res.type === ApiResponseType.SERVER_ERROR || res.type === ApiResponseType.FORM_INVALID) {
                if (res.payload.error === "totp_required") {
                    setTotpRequired(true);
                } else {
                    setResponseMessage(res.payload.message);
                    setResponseMessageClass('error');
                }
            }
            setIsLoading(false);
            return;
        })
    }

    return (
        <Card
            p={'var(--spacing-2xl)'}
            gap={'var(--spacing-xl)'}
        >
            <h1 className="h3 align-center">Login</h1>
            <form onSubmit={captureLogin} className={`login-form${isLoading ? ' loading' : ''}`}>
                <div className="loader"></div>
                <TextInput
                    className={!nameValid ? 'invalid' : ''}
                    onChange={(e:any) => setName(e.target.value)}
                    onKeyDown={(e:any) => {
                        if (e.which === 13) {
                            captureLogin(e);
                        }
                    }}
                    value={name}
                    placeholder='E-Mail oder Kontaktnummer'
                    name='name'
                    ariaLabel='E-Mail oder Kontaktnummer'
                    required={true}
                />
                <PasswordInput
                    className={!passwordValid ? 'invalid' : ''}
                    onChange={(e:any) => setPassword(e.target.value)}
                    onKeyDown={(e:any) => {
                        if (e.which === 13) {
                            captureLogin(e);
                        }
                    }}
                    value={password}
                    placeholder='Passwort'
                    name='password'
                    showToggle={true}
                    ariaLabel='Passwort'
                    required={true}
                    autocomplete='current-password'
                />
                { (responseMessage && responseMessage.length > 0) && (
                    <div className={`bright message${responseMessageClass ? ' ' + responseMessageClass : ''}`} role="alert">
                        <span>
                            {responseMessage}
                        </span>
                    </div>
                ) }

                { totpRequired &&
                    <>
                        <div className={`bright message`} role="alert">Bitte geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein.</div>
                        <TextInput
                            onChange={(e:any) => setTotpCode(e.target.value)}
                            onKeyDown={(e:any) => {
                                if (e.which === 13) {
                                    captureLogin(e);
                                }
                            }}
                            value={totpCode}
                            placeholder='Authentifizierungscode'
                            name='name'
                            ariaLabel='Authentifizierungscode'
                            required={true}
                            type='number'
                        />
                    </>
                }

                <div className='row wrap justify-content-between align-items-center'>
                    <SingleCheckbox
                        onChange={(e:any) => setStayLoggedIn(e.target.checked)}
                        checked={stayLoggedIn}
                        name='stay-logged-in'
                        label='Angemeldet bleiben'
                        labelPosition='after'
                        wrapperClassName='text-xs'
                        className='checkbox-sm'
                    />
                    <Link className="text-xs" to={`/password-forgot`}>Passwort vergessen?</Link>
                </div>
                <Button
                    fullWidth
                    buttonType='primary'
                    onClick={captureLogin}
                >Einloggen</Button>
                <p className="m-0 text-s align-center text-bold">Noch kein Konto?</p>
                <div className="not-registered-action-wrapper">
                    <p className="m-0 text-xs align-center" >
                        <Link to={`/registrierung`}>
                            <Button
                                fullWidth
                                buttonType='primary'
                            >Neu registrieren</Button>
                        </Link>
                    </p>
                    <p className="m-0 text-xs align-center" >
                        <Link to={`/konto-aktivieren`}>
                            <Button
                                fullWidth
                                buttonType='primary'
                            >Konto aktivieren</Button>
                        </Link>
                    </p>
                </div>
            </form>
        </Card>
    )
}

export default LoginForm;